import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
export const SignUpModal = ({ email, password }) => {
  const [show, setShow] = useState(true);

  const handleClose = () => {
    setShow(false);
    setTimeout(() => {
      window.location.reload();
    }, 1200);
  };

  return (
    <>
      <Modal
        backdrop='static'
        keyboard={false}
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Student Account Created</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='text-center'>
            Woohoo, you have successfully created a user
          </p>

          <Form className='p-2'>
            <Form.Label>Student Email</Form.Label>
            <Form.Control value={email} readOnly type='text' />
            <br></br>
            <Form.Label>Student Password</Form.Label>
            <Form.Control value={password} readOnly type='text' />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
